import React from 'react'
import { Block } from 'xadmin'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale-provider/zh_CN'

import './layout.css'

export default class Main extends React.Component {

  render() {
    return (
      <ConfigProvider locale={zhCN}>
        <Block name="root" />
        {this.props.children}
      </ConfigProvider>
    )
  }

}
